const knowledgeBase = [
    {
        disease: "Migraña",
        description:
            "La migraña es un tipo de dolor de cabeza intenso que puede ir acompañado de náuseas y sensibilidad a la luz.",
        relatedAnswers: ["Frontal", "Palpitante", "Dolor de cabeza"],
        similarDiseases: ["Sinusitis"],
        specialists: ["Neurólogo"],
        infoUrl: "https://es.wikipedia.org/wiki/Migra%C3%B1a",
    },
    {
        disease: "Gripe",
        description:
            "La gripe es una infección viral que afecta las vías respiratorias y suele ir acompañada de fiebre, tos y malestar general.",
        relatedAnswers: [
            "Fiebre alta",
            "Escalofríos",
            "Congestión nasal",
            "Fatiga excesiva",
        ],
        similarDiseases: ["COVID-19"],
        specialists: ["Médico general", "Neumólogo"],
        infoUrl: "https://es.wikipedia.org/wiki/Gripe",
    },
    {
        disease: "COVID-19",
        description:
            "El COVID-19 es una enfermedad causada por el coronavirus SARS-CoV-2, que afecta principalmente al sistema respiratorio.",
        relatedAnswers: [
            "Fiebre alta",
            "Tos seca",
            "Fatiga excesiva",
            "Dolor muscular",
        ],
        similarDiseases: ["Gripe"],
        specialists: ["Neumólogo", "Infectólogo"],
        infoUrl: "https://es.wikipedia.org/wiki/COVID-19",
    },
    {
        disease: "Sinusitis",
        description:
            "La sinusitis es la inflamación de los senos paranasales que puede causar dolor facial y congestión nasal.",
        relatedAnswers: ["Dolor de cabeza", "Congestión nasal", "Generalizado"],
        similarDiseases: ["Migraña"],
        specialists: ["Otorrinolaringólogo"],
        infoUrl: "https://es.wikipedia.org/wiki/Sinusitis",
    },
];
export  default  knowledgeBase;